<template>
  <b-col class="py-1">
    <b-row class="nav300 text-center">
      <b-col lg="3" md="3" sm="6" class="my-sm-1 d-none d-lg-block d-sm-block">
        <m-a :href="{name:'Home'}">
          <img class="nav300-logo" :src="findAttributeOnSiteInfo('icon')[0]"
               :alt="findAttributeOnSiteInfo('site_name')[0]">
        </m-a>
      </b-col>
      <b-col lg="6" md="6" sm="12" order="0" order-md="0" order-lg="0" order-sm="1" class="py-2 nav300-search">
        <div class="mx-auto ">
          <m-search-input-3 class="nav300-search mx-auto w-75"/>
        </div>
      </b-col>
      <b-col lg="3" md="3" sm="6" order="1" order-md="1" order-lg="1" order-sm="0" class="py-2 nav300-items">
        <div class="col-lg-12">

          <m-a class="text-dark mx-4 h4" :href="{name:'Dashboard'}">
            <b-icon-person class="my-auto"/>
          </m-a>

          <m-a class="text-dark mx-4 h4" :href="{name:'Products'}">
            <b-icon-card-list class="my-auto  "/>
            <span class="h5 mr-1">منو</span>
          </m-a>

        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: "Nav300"
}
</script>

<style>

.nav300-search .custom-padding {
  padding: 20px 8px !important;
  text-align: right !important;
}

.nav300-search .w-50 {
  width: 100% !important;
}

.nav300-search input {
  border-radius: 0.625rem !important;
  background-color: rgb(235, 237, 240);
}

</style>

<style scoped>
.nav300-logo {
  height: 45px;
}


.nav300-search, .nav300-items, .nav300-dashboard {
  display: table;
}

.nav300-search > div, .nav300-items > div, .nav300-dashboard > div {
  display: table-cell;
  vertical-align: middle;
}

</style>